import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalNotificaciones from "./ModalNotificaciones";
import NavLinks from './NavLinks'
import authService from '../../services/authService'
import { useDispatch, useSelector } from "react-redux";
//import DefaultImg from '../../SVG/default.svg'
import DefaultImg from '../../assets/NoPhoto.png'

import {  obtenerNotificacionesUsuario } from '../../redux/usuariosSlice'
import { getHeader } from '../../Api/content'
import { useLocale } from '../../i18n/localeContext'
import { Skeleton } from 'antd'
import { StrapiError } from '../../Inicio/Pages/StrapiError';

export default function UserInfo({ usuario }) {
  const user = usuario;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { notificaciones } = useSelector((state) => state.usuarios);

  const [notifState, changeNotifState] = useState(false);
  const [image, setImage] = useState('');
  const [header, setHeader] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const [hasError, setHasError] = useState(false);       // 👈 nuevo
  const [retryIndex, setRetryIndex] = useState(0);       // 👈 nuevo (para reintentos)

  const { locale } = useLocale();

  useEffect(() => {
    dispatch(obtenerNotificacionesUsuario());
  }, [dispatch]);

  useEffect(() => {
    if (user?.usuarioId) {
      if (user?.foto) {
        setImage(`data:image/jpg;base64, ${user?.foto}`);
      } else {
        setImage(DefaultImg);
      }
    }
  }, [user]);

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);

    const fail = () => {
      if (cancel) return;
      setHeader(null);
      setIsLoadingContent(false);
      setHasError(locale === 'en'); // mismo criterio que usaste en VistaInicio
    };

    const timeoutId = setTimeout(fail, 5000);

    getHeader(locale)
      .then((res) => {
        if (cancel) return;
        const data = res?.data?.attributes || res?.data || res;
        setHeader(data);
        setIsLoadingContent(false);
      })
      .catch(() => {
        if (cancel) return;
        fail();
      })
      .finally(() => {
        clearTimeout(timeoutId);
      });

    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]); // solo locale, no retryIndex para evitar loops

  const clickedButton = () => {
    const profile = document.getElementsByClassName('menuPerfil')[0];
    const toggle = document.querySelector('.toggleBtn');
    const closeBar = document.querySelectorAll('.toggleBtn');

    closeBar.forEach((el) => {
      el.classList.toggle('invisibleBtn');
    });

    profile.classList.toggle('Active');
    toggle.classList.toggle('toggleBlue');
  };

  // ⏳ Loading (igual que tenías)
  if (isLoadingContent) {
    return (
      <div className="menuPerfil">
        <div>
          <Skeleton.Button style={{ width: 40, height: 40 }} active />
          <Skeleton.Button style={{ width: 40, height: 40 }} active />
          <Skeleton.Button style={{ width: 40, height: 40 }} active />
        </div>
        <div>
          <Skeleton.Image style={{ width: 80, height: 80 }} active />
          <Skeleton.Input style={{ width: 200, height: 25 }} active />
          <div className="profileInfo">
            <hr />
            <div>
              <Skeleton.Input style={{ width: 150, height: 20 }} active />
            </div>
            <div>
              <Skeleton.Input style={{ width: 180, height: 20 }} active />
            </div>
            <div>
              <Skeleton.Input style={{ width: 120, height: 20 }} active />
            </div>
          </div>
          <Skeleton.Button style={{ width: 180, height: 40 }} active />
          <div className="sidebar-ul">
            <Skeleton active paragraph={{ rows: 4 }} />
          </div>
        </div>
      </div>
    );
  }

  // 🚨 Overlay de error (mismo patrón)
  if (hasError && locale === 'en') {
    return (
      <StrapiError
        onRetry={() => {
          setHasError(false);
          setIsLoadingContent(true);
          setRetryIndex((i) => i + 1); // fuerza re-fetch
        }}
        onUseDefault={() => {
          setHasError(false);
          setIsLoadingContent(false);
          setHeader(null); // usar fallback sin header
        }}
      />
    );
  }

  return (
    <>

      <div className="menuPerfil">
        <div>
          <ModalNotificaciones
            estado={notifState}
            cambiarEstado={changeNotifState}
            notificaciones={notificaciones}
          />
          <button
            className="btnNotificacion"
            onClick={() => { changeNotifState(true); }}
          >
            <i className="material-icons"></i>
          </button>
          <button
            className="btnNotificacion"
            onClick={() => { clickedButton(); navigate("/configuracion") }}
          >
            <i className="material-icons"></i>
          </button>
          <button
            className="btnNotificacion"
            onClick={() => { clickedButton(); authService.logout(navigate) }}
          >
            <i className="material-icons"></i>
          </button>
        </div>
        <div>
          <img
            id="profileImg"
            className="imagen-cuadrada"
            src={image}
            alt="Foto de perfil"
          />
          <h2>{user?.nombres} {user?.primerApellido} {user?.segundoApellido}</h2>
          <div className="profileInfo">
            <hr />
            <div>
              <label>              <i className="material-icons"></i>

                {user?.dni}</label>
            </div>
            <div>

              <label>
                <i className="material-icons"></i>{user?.correoElectronico}</label>
            </div>
            <div>
              <label><i className="material-icons"></i>{user?.telefono}</label>
            </div>
          </div>
          <button id="btnEdit" onClick={() => {
            clickedButton();
            navigate('userInfo');
          }}>
            {header?.edit_button || 'Editar Información'}
          </button>

          <div className="sidebar-ul">
            <NavLinks />
          </div>
        </div>
      </div>
    </>
  );
}
